import * as React from 'react';
import ouiStyle from '@goldwasserexchange/oui-style';
import { BondSAccIdProvider } from '../../../../../../../../../../../../../../../../../../actor/api/Services/bonds';
import { NewsBondElementContent } from './components';

export const NewsBondsElement = (props: {
  sAccId: number,
  transform?: ouiStyle.InStyleWithMediaQueries['transform'],
  position?: ouiStyle.InStyleWithMediaQueries['position'],
  top?: ouiStyle.InStyleWithMediaQueries['top'],
  bottom?: ouiStyle.InStyleWithMediaQueries['bottom'],
  left?: ouiStyle.InStyleWithMediaQueries['left'],
  right?: ouiStyle.InStyleWithMediaQueries['right'],
}) => {
  const {
    sAccId,
    transform,
    position,
    top,
    bottom,
    left,
    right,
  } = props;
  return (
    <BondSAccIdProvider id={sAccId}>
      <NewsBondElementContent
        transform={transform}
        position={position}
        top={top}
        bottom={bottom}
        left={left}
        right={right}
      />
    </BondSAccIdProvider>
  );
};
